import { Record } from 'immutable';

import { TimelineListEntity } from '../components/timeline-list/timeline-list.entity';

export const TimelineSliceKey = 'main';

export interface ITimelineMainSliceState {
	loading: boolean;
	list: TimelineListEntity;
	deleteSuccess: boolean;
}

export const defaults: ITimelineMainSliceState = {
	loading: false,
	list: TimelineListEntity.build([]),
	deleteSuccess: false,
};

export class TimelineMainSliceState extends Record<ITimelineMainSliceState>(
	defaults
) {
	public static readonly key = TimelineSliceKey;

	public setLoading(isLoading: boolean): TimelineMainSliceState {
		return this.set('loading', isLoading);
	}

	public setTimelineList(
		timelineList: TimelineListEntity
	): TimelineMainSliceState {
		return this.set('list', timelineList);
	}

	public setDeleteSuccess(isSuccess: boolean): TimelineMainSliceState {
		return this.set('deleteSuccess', isSuccess);
	}
}
